import { gql, useMutation } from '@apollo/client';

import { Server } from '../apollo/types';
import { useVisitorId } from './useVisitorId';

export type RecordClientMeasureData = {
  recordClientMeasure: {
    recordedAt: string;
  };
};

export type RecordClientMeasureVariables = {
  visitorId: string;
  providerShortId?: string;
};
export const RECORD_CLIENT_MEASURE = gql`
  mutation RecordClientMeasureVisitor($visitorId: String!, $providerShortId: String) {
    recordClientMeasure(visitorId: $visitorId, providerShortId: $providerShortId) {
      recordedAt
    }
  }
`;

export function useRecordClientMeasure(providerShortId?: string) {
  const visitorId = useVisitorId();
  return useMutation<RecordClientMeasureData, RecordClientMeasureVariables>(RECORD_CLIENT_MEASURE, {
    variables: { visitorId, providerShortId },
    context: { server: Server.TELEHEALTH },
  });
}
